export const homologationConstants = {
    INSERT_REQUEST: 'Homologation_INSERT_REQUEST',
    INSERT_SUCCESS: 'Homologation_INSERT_SUCCESS',
    INSERT_FAILURE: 'Homologation_INSERT_FAILURE',
};   